import React from 'react'

export default class SketchizeInfo extends React.Component {
    render() {
        return (
            <div className="sketchize-info">
                <ul>
                    <li>Version: 1.0.0</li>
                    <li><a className="github-icon" href="https://github.com/selfishprimate/sketchize" target="_blank" rel="noopener noreferrer">GitHub Project</a></li>
                    <li>Created by <a href="https://www.linkedin.com/in/selfishprimate/" target="_blank" rel="noopener noreferrer">Halil İbrahim Çakıroğlu</a></li>
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SketchizeInfo/SketchizeInfo.js